





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { CartItem } from '@/services/cart/model/cart';
import { ProductDto } from '@eurogast/hub-client-typescript';
import MatomoEvents from '@/matomo/events/MatomoEvents';
import { DependencyService } from '@/services/DependencyService';
import CartButtonMessage from '@/common/cart-button/CartButtonMessage.vue';
import { LinkUtil } from '@/services/LinkUtil';

@Component({
  components: { CartButtonMessage }
})
export default class UnavailableItem extends Vue {
  @Prop({ required: true })
  private item: CartItem;

  private cartService = DependencyService.getCartService();

  get product(): ProductDto {
    return this.item.product;
  }

  get detailUrl(): string {
    return LinkUtil.getProductDetailUrl(this.product.name, this.product.sku);
  }

  get productImagePath(): string {
    return LinkUtil.getProductImageUrl(this.product);
  }

  get subTitle(): string {
    return this.$t('common.product.withSku', { sku: this.product.sku }).toString();
  }

  public removeFromCart() {
    MatomoEvents.forCartPage.removeItem.publish();
    this.cartService.removeItem(this.item);
  }
}
